import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';

export default function LatestTransactionsTable() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';
    const fetchData = () => {
      fetch(`${API_BASE_URL}/api/transactions?limit=50`)
        .then(res => res.json())
        .then(data => { if (isMounted) setTransactions(data); });
    };
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return (
    <Card sx={{ mt: 4 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>Latest 50 Transactions</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>LexiFi Link</TableCell>
              <TableCell>Contract ID</TableCell>
              <TableCell>Product Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Import Status</TableCell>
              <TableCell>Verification Message</TableCell>
              <TableCell>Created Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map(tx => {
              // Conditional row background coloring
              let bgColor = '';
              if (tx.import_status === 'imported') {
                bgColor = '#e3fcef'; // light green
              } else if (tx.status === 'verified') {
                bgColor = '#e3f2fd'; // light blue
              } else if (!tx.verified) {
                bgColor = '#ffebee'; // light red
              } else {
                bgColor = '#fffde7'; // light yellow
              }
              // Truncate verification message to 50 chars, show full on hover
              const verificationMsg = tx.verification_message || '';
              const truncatedMsg = verificationMsg.length > 50 ? verificationMsg.slice(0, 50) + '…' : verificationMsg;
              return (
                <TableRow key={tx._id} sx={{ background: bgColor }}>
                  <TableCell>{tx.lexiFi_link}</TableCell>
                  <TableCell>{tx.contract_id}</TableCell>
                  <TableCell>{tx.product_type_name}</TableCell>
                  <TableCell>{tx.status}</TableCell>
                  <TableCell>{tx.import_status}</TableCell>
                  <TableCell title={verificationMsg}>{truncatedMsg}</TableCell>
                  <TableCell>{tx.createdAt ? new Date(tx.createdAt).toLocaleDateString() : ''}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
